/** Combining diacritical marks (U+0300–U+036F) left behind by NFD normalization. */
const COMBINING_MARKS = /[\u0300-\u036f]/g;

/** Case- and accent-insensitive substring match. */
export const matchesQuery = (query: string, ...texts: string[]): boolean => {
	const fold = (s: string) => s.normalize('NFD').replaceAll(COMBINING_MARKS, '').toLowerCase();
	const needle = fold(query.trim());

	return needle === '' || texts.some((text) => fold(text).includes(needle));
};
